import React, { Component } from 'react';

import 'assets/scss/dashboard.css';
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import DashboardMetricsApi from 'apis/DashboardMetrices';
import { getDashboardMetricObject } from 'constants/localStorageManager';
import { createLayoutConfig } from 'utils/metricesHelper';
import { testMobileBrowser } from 'utils/browserHelpers';
import Toaster from 'components/Toaster';

import Metric from 'components/dashboard/Metric';
import DashboardGuide from 'components/dashboard/DashboardGuide';
import DeleteConfigurationModal from 'components/dashboard/DeleteConfigurationModal.js';
import OnboardingModal from 'components/dashboard/OnboardingModal.js';

class Dashboard extends Component {
  constructor() {
    super();
    this.state = {
      isMetricsModalVisible: false,
      isMetricsConfigVisible: false,
      dashboardComponents: [],
      activeType: '',
      removeConfigModal: false,
      showOnboardingModal: false,
      dashboard_components_attributes: [],
      layout: [],
      isMobileBrowser: true
    };
  }

  componentDidMount = () => {
    this.checkNavigatorState();
    this.fetchDashboardComponents();
  }

  fetchDashboardComponents = () => {
    const { id } = getDashboardMetricObject();

    if (!id) return;

    DashboardMetricsApi.getAll(id).then(({ data }) => {
      this.setState({ dashboardComponents: [] }, () => this.setState({ dashboardComponents: data }));
    }).catch(console.log);
  }

  onMetricsSelected = (title, type) => {
    this.toggleMetricsConfig({ title, type });
  }

  toggleMetricsModal = () => {
    this.setState(prevState => ({
      isMetricsModalVisible: !prevState.isMetricsModalVisible
    }));
  }

  toggleMetricsConfig = (componentData) => {
    const { id, title, type } = componentData;

    this.setState(prevState => ({
      isMetricsConfigVisible: !prevState.isMetricsConfigVisible,
      isMetricsModalVisible: false,
      editComponentId: id,
      configModalTitle: title,
      activeType: type
    }));
  }

  onLayoutChange = (layout) => {
    const isMobileBrowser = testMobileBrowser();
    if (!layout || isMobileBrowser) return;

    let dashComps = this.state.dashboardComponents.slice();
    let dashboard_components_attributes = [];

    for (let j = 0; j < layout.length; j++) {
      const dashComponent = dashComps.find(dash => dash.layout_config.i === layout[j].i);
      if (!dashComponent) {
        continue;
      }

      Object.keys(layout[j]).forEach(key => layout[j][key] === undefined ? delete layout[j][key] : '');
      delete layout[j].moved;

      if (layout[j].x === dashComponent.layout_config.x && layout[j].y === dashComponent.layout_config.y) {
        continue;
      }
      const newComp = {
        id: dashComponent.id,
        layout_config: layout[j]
      }
      dashboard_components_attributes.push(newComp);
    }

    this.updateMetricsConfig(dashboard_components_attributes);
  }

  updateMetricsConfig = (data) => {
    if (data.length < 1) return;

    const { id } = getDashboardMetricObject();
    DashboardMetricsApi.updateComponents(id, { dashboard: { dashboard_components_attributes: data } }).catch((e) => {
      console.log(e)
    });
  }

  saveMetricConfig = (data) => {
    let { editComponentId } = this.state;

    if (!editComponentId) {
      editComponentId = data.id;
    }

    const configData = { dashboard_config: data };
    DashboardMetricsApi.saveConfig(editComponentId, configData).then(() => {
      this.fetchDashboardComponents();
      this.setState({
        isMetricsConfigVisible: false
      });
      Toaster.getSuccessToaster('check-circle', 'Configuration updated Successfully');
    }).catch(() => {
      Toaster.getErrorToaster('exclamation-triangle', 'Configuration update failed');
    });
  }

  addNewMetric = (data, width = 3, height = 4) => {
    const { dashboardComponents } = this.state;
    const layout_config = createLayoutConfig(dashboardComponents, width, height);
    const newDashboardComponent = { dashboard_config: data, layout_config };
    const { id } = getDashboardMetricObject();
    DashboardMetricsApi.addNew(id, newDashboardComponent).then(({ data }) => {
      this.fetchDashboardComponents();
      this.setState({
        isMetricsConfigVisible: false
      });
      Toaster.getSuccessToaster('check-circle', 'Configuration added Successfully');
    }).catch(() => {
      Toaster.getErrorToaster('exclamation-triangle', 'Adding Configuration failed');
    });
  }

  deleteMetric = () => {
    const { editComponentId } = this.state;

    DashboardMetricsApi.deleteConfig(editComponentId).then(({ data }) => {
      this.setState({
        isMetricsConfigVisible: false
      });
      this.fetchDashboardComponents();
      Toaster.getSuccessToaster('check-circle', 'Configuration removed Successfully');
    }).catch(() => {
      Toaster.getErrorToaster('exclamation-triangle', 'Removing Configuration failed');
    })
    this.toggleRemoveConfigModal();
  }

  checkNavigatorState = () => {
    const isMobileBrowser = testMobileBrowser();
    this.setState({
      isMobileBrowser
    })
  }

  toggleRemoveConfigModal = (configId = '') => {
    this.setState({
      removeConfigModal: !this.state.removeConfigModal,
      editComponentId: configId
    });
  }

  toggleRemoveOnboardingModal = () => {
    this.setState({
      showOnboardingModal: !this.state.showOnboardingModal,
    });
  }

  render() {
    const {
      isMetricsModalVisible,
      isMetricsConfigVisible,
      dashboardComponents,
      editComponentId,
      configModalTitle,
      activeType,
      removeConfigModal,
      showOnboardingModal,
      isMobileBrowser
    } = this.state;

    return (
      <div className="container">
        <DeleteConfigurationModal
          isVisible={removeConfigModal}
          toggleRemoveConfigModal={this.toggleRemoveConfigModal}
          id={editComponentId}
          deleteMetric={this.deleteMetric} />

        <OnboardingModal
          isVisible={showOnboardingModal}
          toggleRemoveOnboardingModal={this.toggleRemoveOnboardingModal}
        />

        {(dashboardComponents.length === 0) && (
          <DashboardGuide />
        )}

        <Metric
          configModalTitle={configModalTitle}
          addNewMetric={this.addNewMetric}
          saveMetricConfig={this.saveMetricConfig}
          onLayoutChange={this.onLayoutChange}
          handleConfigDataChanged={this.handleConfigDataChanged}
          editComponentId={editComponentId}
          toggleMetricsModal={this.toggleMetricsModal}
          onMetricsSelected={this.onMetricsSelected}
          toggleMetricsConfig={this.toggleMetricsConfig}
          dashboardComponents={dashboardComponents}
          isMetricsModalVisible={isMetricsModalVisible}
          isMetricsConfigVisible={isMetricsConfigVisible}
          activeType={activeType}
          toggleRemoveConfigModal={this.toggleRemoveConfigModal}
          isMobileBrowser={isMobileBrowser}
          checkNavigatorState={this.checkNavigatorState}
        />
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/dashboard/MeasureOfSuccess.js